import { getBlockDefinition } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'

import { gridDragConfig, gridResizeConfigs, gridResizeHandles } from '../constants'

const getBlockResizeHandles = blockId => {
  if (getBlockDefinition(blockId).aspectRatioSetting) return gridResizeHandles.all

  return gridResizeHandles.horizontal
}

export const getResizableLayout = (layout, selectedBlockId, resizeEnabled) => {
  if (!resizeEnabled) return layout.map(item => ({ ...item, isResizable: false }))

  return layout.map(item => ({
    ...item,
    isResizable: item.i === selectedBlockId,
    resizeHandles: getBlockResizeHandles(item.i),
  }))
}

export const getVisibleLayout = (layout, hiddenBlocks) => layout.filter(item => !hiddenBlocks[item.i])

export const getGridInteraction = ({ isLayoutLocked, viewMode, onLayoutChange }) => {
  if (isLayoutLocked) return {}

  return { dragConfig: gridDragConfig, resizeConfig: gridResizeConfigs[viewMode], onLayoutChange }
}
